/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiAgentConfigDisable } from '../../axios/whatsAppAiAgentConfigDisable'
import type {
	WhatsAppAiAgentConfigDisableError,
	WhatsAppAiAgentConfigDisablePathParams,
	WhatsAppAiAgentConfigDisableResponse,
} from '../../types/WhatsAppAiAgentConfigDisable'

export const whatsAppAiAgentConfigDisableMutationKey = () =>
	[{ url: '/campaigns/:campaignId/whatsapp-ai-config/disable' }] as const

export type WhatsAppAiAgentConfigDisableMutationKey = ReturnType<typeof whatsAppAiAgentConfigDisableMutationKey>

export type WhatsAppAiAgentConfigDisableVariables = {
	campaignId: WhatsAppAiAgentConfigDisablePathParams['campaignId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::disable */
export function useWhatsAppAiAgentConfigDisable<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppAiAgentConfigDisableResponse,
		AxiosError<WhatsAppAiAgentConfigDisableError>,
		WhatsAppAiAgentConfigDisableVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppAiAgentConfigDisableMutationKey(),
		mutationFn: ({ campaignId }: WhatsAppAiAgentConfigDisableVariables) =>
			whatsAppAiAgentConfigDisable(campaignId, config).then(res => res.data),
		...options,
	})
}
